const AccountingAppletPermissions = {

    sections: {

        admin: {
            key: 'admin',
            title: '{{lang}}admin',
            hasExtraHeaders: false,
            headers: {
                view: { key: 'view', title: '{{lang}}view', main: true },
                create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
            },



            permissions: {


                FAQ: {
                    key: 'FAQ',
                    title: '{{lang}}FAQ',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },



                dynamicPages: {
                    key: 'dynamicPages',
                    title: '{{lang}}dynamicPages',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


                users: {
                    key: 'users',
                    title: '{{lang}}users',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },
                partners: {
                    key: 'partners',
                    title: '{{lang}}partners',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },
                accounts: {
                    key: 'accounts',
                    title: '{{lang}}accounts',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


                Blogs: {
                    key: 'Blogs',
                    title: '{{lang}}Blogs',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


                addresses: {
                    key: 'addresses',
                    title: '{{lang}}addresses',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },

                orders: {
                    key: 'orders',
                    title: '{{lang}}orders',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


                specifications: {
                    key: 'specifications',
                    title: '{{lang}}specifications',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


                fallowRepairReq: {
                    key: 'fallowRepairReq',
                    title: ' درخواست پیگیری تعمیرات',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },

                imeiRequest: {
                    key: 'imeiRequest',
                    title: ' درخواست imei ',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },



                partnershipRepairReq: {
                    key: 'partnershipRepairReq',
                    title: ' درخواست نمایندگی خدمات پس از فروش  ',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


                partnershipReq: {
                    key: 'partnershipReq',
                    title: ' درخواست نمایندگی فروش  ',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


                complains: {
                    key: 'complains',
                    title: 'شکایات  ',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


                survey: {
                    key: 'survey',
                    title: 'فرم های نظرسنجی',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


                Products: {
                    key: 'Products',
                    title: '{{lang}}Products',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


                brands: {
                    key: 'brands',
                    title: '{{lang}}Brands',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },



                categories: {
                    key: 'categories',
                    title: '{{lang}}categories',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


                employees: {
                    key: 'employees',
                    title: '{{lang}}employees',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


                baners: {
                    key: 'baners',
                    title: '{{lang}}baners',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },





                permissions: {
                    key: 'permissions',
                    title: '{{lang}}permissions',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },



            }
        },




        // trading: {
        //     key: 'trading',
        //     title: '{{lang}}trading',
        //     hasExtraHeaders: false,
        //     headers: {
        //         view: { key: 'view', title: '{{lang}}view', main: true },
        //         create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
        //         edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
        //         delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
        //     },
        //     permissions: {
        //         tequipments: {
        //             key: 'tequipments',
        //             title: '{{lang}}Trading Equipments',
        //             headers: {
        //                 view: { key: 'view', title: '{{lang}}view', main: true },
        //                 create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
        //                 edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
        //                 delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
        //             }
        //         },

        //         tcategories: {
        //             key: 'tcategories',
        //             title: '{{lang}}Trading categories',
        //             headers: {
        //                 view: { key: 'view', title: '{{lang}}view', main: true },
        //                 create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
        //                 edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
        //                 // create: { key: 'sendEmail', title: '{{lang}}Send Email', dependancy: 'view', main: true },
        //                 delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
        //             }
        //         },

        //         tattributes: {
        //             key: 'tattributes',
        //             title: '{{lang}}Trading attributes',
        //             headers: {
        //                 view: { key: 'view', title: '{{lang}}view', main: true },
        //                 create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
        //                 edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
        //                 // create: { key: 'sendEmail', title: '{{lang}}Send Email', dependancy: 'view', main: true },
        //                 delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
        //             }
        //         },

        //         trequests: {
        //             key: 'trequests',
        //             title: '{{lang}}Trading Requests',
        //             headers: {
        //                 view: { key: 'view', title: '{{lang}}view', main: true },
        //                 create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
        //                 edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
        //                 // create: { key: 'sendEmail', title: '{{lang}}Send Email', dependancy: 'view', main: true },
        //                 delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
        //             }
        //         },


        //         tplaces: {
        //             key: 'tplaces',
        //             title: '{{lang}}Trading Places',
        //             headers: {
        //                 view: { key: 'view', title: '{{lang}}view', main: true },
        //                 create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
        //                 edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
        //                 // create: { key: 'sendEmail', title: '{{lang}}Send Email', dependancy: 'view', main: true },
        //                 delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
        //             }
        //         },


        //         tmessenger: {
        //             key: 'tmessenger',
        //             title: '{{lang}}Trading Messenger',
        //             headers: {
        //                 view: { key: 'view', title: '{{lang}}view', main: true },
        //                 create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
        //                 edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
        //                 // create: { key: 'sendEmail', title: '{{lang}}Send Email', dependancy: 'view', main: true },
        //                 delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
        //             }
        //         },


        //     }
        // }




    }

}


export { AccountingAppletPermissions }